


export const jurFormVoList = JSON.stringify([
    {
        isForm: 1,
        isShowForm: 0,
        jciId: 11717,
        jciName: "出库申请主信息表单",
        jciType: 1,
        index: 0,
        jurId: "1698307975196",
        jurconfigform: [
            {
                chineseField: "销售日期",
                defaultValue: "",
                entityField: "woamSaledate",
                extractId: null,
                fieldType: "date",
                fieldWeight: 180,
                focusField: "",
                isChange: 0, isUpdate: 0
            },
            {
                chineseField: "销售单位",
                defaultValue: "",
                entityField: "cmName",
                extractId: null,
                fieldType: "search",
                setField: "cmName,cmId",
                fieldWeight: 180,
                focusField: "",
                isChange: 0, isUpdate: 0
            },
            {
                chineseField: "业务员",
                defaultValue: "",
                entityField: "opmName",
                extractId: null,
                fieldType: "search",
                fieldWeight: 180,
                setField: "opmName,opmId",
                focusField: "",
                isChange: 0, isUpdate: 0
            },
            {
                chineseField: "业务部门",
                defaultValue: "",
                entityField: "depName",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 0, isUpdate: 0
            },
            {
                chineseField: "对方业务员",
                defaultValue: "",
                entityField: "salesName",
                extractId: null,
                fieldType: "search",
                fieldWeight: 180,
                setField: "salesName,salesId",
                focusField: "",
                isChange: 0, isUpdate: 0
            },
            {
                chineseField: "地址",
                defaultValue: "",
                entityField: "caiAddress",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 0, isUpdate: 0
            },
            {
                chineseField: "收货员",
                defaultValue: "",
                entityField: "recName",
                extractId: null,
                fieldType: "search",
                fieldWeight: 180,
                setField: "recName,recId",
                focusField: "",
                isChange: 0, isUpdate: 0
            },
            {
                chineseField: "货主名称",
                defaultValue: "",
                entityField: "coName",
                extractId: null,
                fieldType: "search",
                fieldWeight: 180,
                setField: "coName,coId",
                focusField: "",
                isChange: 0, isUpdate: 0
            },
            {
                chineseField: "手术时间",
                defaultValue: "",
                entityField: "operationTime",
                extractId: null,
                fieldType: "date",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "科室",
                defaultValue: "",
                entityField: "roomName",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "病人姓名",
                defaultValue: "",
                entityField: "patientName",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "住院号",
                defaultValue: "",
                entityField: "courtNum",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "病人电话",
                defaultValue: "",
                entityField: "patientPhone",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "身份证号",
                defaultValue: "",
                entityField: "idcardNum",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
            {
                chineseField: "备注",
                defaultValue: "",
                entityField: "wsRemark",
                extractId: null,
                fieldType: "string",
                fieldWeight: 180,
                focusField: "",
                isChange: 1, isUpdate: 0
            },
        ]
    }

]
)
export const tabledata = [
    {
        chineseField: "商品编号",
        defaultValue: "",
        entityField: "bgmCode",
        extractId: null,
        fieldType: "string",
        fieldWeight: 150,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "商品名称",
        defaultValue: "",
        entityField: "bgmName",
        extractId: null,
        fieldType: "search",
        fieldWeight: 180,
        focusField: "",
        nosetField:"woadPnumber,psprice,psmoney,price,money,woadRemark",
        riftField:"bgmId",
        searchId: 919354910904320,
        setField:"bgmName,bgmId",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "规格",
        defaultValue: "",
        entityField: "spec",
        extractId: null,
        fieldType: "string",
        fieldWeight: 150,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "生产厂商",
        defaultValue: "",
        entityField: "manufacturer",
        extractId: null,
        fieldType: "string",
        fieldWeight: 150,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "产地",
        defaultValue: "",
        entityField: "placeorigin",
        extractId: null,
        fieldType: "string",
        fieldWeight: 100,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "包装单位",
        defaultValue: "",
        entityField: "bgpUnitmeasurement",
        extractId: null,
        fieldType: "string",
        fieldWeight: 100,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "装箱规格",
        defaultValue: "",
        entityField: "packingSpec",
        extractId: null,
        fieldType: "string",
        fieldWeight: 100,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "批号",
        defaultValue: "",
        entityField: "batchno",
        extractId: null,
        fieldType: "string",
        fieldWeight: 120,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "生产日期",
        defaultValue: "",
        entityField: "prodate",
        extractId: null,
        fieldType: "date",
        fieldWeight: 110,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "失效日期",
        defaultValue: "",
        entityField: "expidate",
        extractId: null,
        fieldType: "date",
        fieldWeight: 110,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "灭菌批号",
        defaultValue: "",
        entityField: "sterBatchno",
        extractId: null,
        fieldType: "string",
        fieldWeight: 110,
        focusField: "",
        isChange: 0, isUpdate: 0
    },
    {
        chineseField: "使用数量",
        defaultValue: "",
        entityField: "useNum",
        extractId: null,
        fieldType: "string",
        fieldWeight: 110,
        focusField: "keydown",
        isChange: 0, isUpdate: 0
    },
    
    

]